<template>
  <div class="main-content">
    <div class="load-content">
      <div class="seg-container">
        <div class="ul-content">
          <div class="li-item seg-active tag-unstart">
            <div class="li-name">
              已完成报名，资格赛待开始
            </div>
            <div class="li-times">
              2025-09-27 至 2025-09-27
            </div>
          </div>
        </div>
      </div>
      <div class="assessment-content">
        <div class="right-part">
          <div>
            <div class="live-notyet">
              <div class="nodata_bg_img"><img src="https://www.ttcdw.cn/p/uc/static/img/empty_bg.ebf669a.png">
                <p class="notyet-text">此阶段尚未开始，请耐心等待</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="el-loading-mask" style="display: none;">
      <div class="el-loading-spinner"><svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg></div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    step: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {

    }
  },
  components: {

  },
  created() {

  },
  mounted() {
    document.title = '山西省第三届家庭教育指导技能大赛报名'
  },
  computed: {

  },
  methods: {


  },

}
</script>
<style lang="scss" scoped>
.main-content {
  width: 1200px;
  margin: 0 auto;
  margin-top: 10px;
  min-height: 60vh;
  .load-content {
    display: flex;
    justify-content: flex-start;

    .seg-container {
      width: 240px;
      margin-bottom: 20px;

      .ul-content {
        .seg-active {
          background: rgba(59, 112, 255, 0.16);
          box-shadow: 1px 1px 8px 0px rgba(0, 0, 0, 0.08);
          border: 1px solid #3B70FF;
        }

        .tag-unstart::after {
          content: "";
          background: url('https://www.ttcdw.cn/p/uc/static/img/seg_status_unstart.744ec00.png') no-repeat;
          background-size: 100% 100%;
          position: absolute;
          width: 52px;
          height: 22px;
          left: -1px;
          top: -6px;
        }

        .li-item {
          padding: 23px 12px;
          margin-bottom: 15px;
          background-size: 100% 100%;
          background: #FFFFFF;
          box-shadow: 1px 1px 8px 0px rgba(0, 0, 0, 0.08);
          border-radius: 4px;
          position: relative;
          cursor: pointer;

          .li-name {
            font-size: 16px;
            color: #333;
            line-height: 22px;
            margin-bottom: 10px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }

          .li-times {
            font-size: 14px;
            color: #999999;
            line-height: 20px;
          }
        }
      }
    }

    .assessment-content {
      flex: 1;
      margin-left: 10px;
      background: #fff;
      padding: 15px 20px;
      font-size: 13px;
      border-radius: 4px;

      .right-part {
        .live-notyet {
          height: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;

          .nodata_bg_img {
            img {
              width: 350px;
            }

            .notyet-text {
              font-size: 16px;
              color: #999999;
              line-height: 22px;
              font-weight: 500;
              color: #333333;
              text-align: center;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-break: break-all;
            }
          }
        }
      }
    }
  }
}
</style>
